import { IconButton, TextField, Box } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IosShareIcon from '@mui/icons-material/IosShare';
import Card from '../common/cards/Card';
import styles from '../../components/common/comments/styles.module.scss';
import DefaultAvatar from '../../assets/icons/svgIcons/avatar.svg';
import Avatar from '@material-ui/core/Avatar';
import { parseDate } from '../../helpers/date';
import {
  getKudosReplyCommentListRequest,
  sendCommentRequest
} from '../pages/KudosDetail/api';
import { useQuery, useMutation } from '@tanstack/react-query';
import Loader from '../common/Loader';
import { toast } from 'react-toastify';
import { useTranslation } from '../../i18n/LanguageProvider';

const ReplyCommentDialog = ({ kudosId, commentId }) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState(null);

  const { data, isLoading, refetch } = useQuery(
    ['commentList', kudosId, commentId],
    () => getKudosReplyCommentListRequest(kudosId, commentId),
    {
      onError(error) {
        toast.error(error.response?.data?.detail);
      }
    }
  );

  const sendCommentMutation = useMutation(sendCommentRequest, {
    onSuccess() {
      setComment('');
      toast.success(t('comments.sent'));
      refetch();
    },
    onError(error) {
      toast.error(error.response?.data?.detail);
    }
  });

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {console.log(data.length)}
          <div
            className={styles.wrapper}
            style={{ marginTop: '16px', marginBottom: '16px' }}
          >
            {data?.length ? (
              data?.map((comment) => (
                <Box key={comment.id} mt={2} mb={2}>
                  <Card>
                    <div className={styles.wrapper}>
                      <div className={styles.body}>
                        <div className={styles.info}>
                          <div className={styles.pics}>
                            <Avatar
                              alt={comment.sender.first_name}
                              src={
                                comment.sender.avatar?.thumbnail ||
                                DefaultAvatar
                              }
                              className={styles.small}
                            />
                            <span>
                              {`${comment.sender.first_name} ${comment.sender.last_name}`}
                              <div className={styles.time}>
                                {parseDate(comment.created_at)}
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className={styles.note} dir="auto">
                        {comment.comment}
                      </div>
                    </div>
                  </Card>
                </Box>
              ))
            ) : (
              <div className={styles.empty}>{t('comments.empty')}</div>
            )}
            <Box mt={2} mb={2}></Box>
          </div>

          <form
            style={{ position: 'absolute', left: 0, bottom: 0, right: 0 }}
            onSubmit={(e) => {
              e.preventDefault();
              sendCommentMutation.mutate({
                kudos_id: kudosId,
                comment: comment,
                parent_id: commentId
              });
            }}
          >
            <TextField
              onChange={(e) => setComment(e.target.value)}
              name="comment"
              value={comment}
              fullWidth
              label={t('comments.placeholder')}
              defaultValue={comment}
              InputProps={{
                endAdornment: (
                  <IconButton disabled={sendCommentMutation.isLoading}>
                    {!!comment && (
                      <IosShareIcon
                        onClick={() => {
                          sendCommentMutation.mutate({
                            kudos_id: kudosId,
                            comment: comment,
                            parent_id: commentId
                          });
                        }}
                        color="primary"
                      />
                    )}{' '}
                  </IconButton>
                )
              }}
            />
          </form>
        </>
      )}
    </>
  );
};

ReplyCommentDialog.propTypes = {
  commentId: PropTypes.number,
  kudosId: PropTypes.number
};

export default ReplyCommentDialog;
